import { Link } from 'react-router';
import { Logo } from '../../shared/ui/components';
import '../landing/landing.css';

/** Versión vigente del Aviso de Privacidad (se guarda con el consentimiento de cada cuenta). */
export const PRIVACY_VERSION = '2026-10-01';
const CONTACT = 'privacidad@mykeora.com';

/** Aviso de Privacidad Integral de KEORA (Ley Federal de Protección de Datos Personales en Posesión de los Particulares). */
export function PrivacyPage() {
  return (
    <div className="landing">
      <header className="landing__bar">
        <Link to="/" aria-label="Inicio">
          <Logo />
        </Link>
      </header>
      <main className="legal">
        <h1>Aviso de Privacidad Integral</h1>
        <p className="muted">Última actualización: 1 de octubre de 2026</p>

        <h2>1. Responsable</h2>
        <p>
          <strong>KEORA</strong> (mykeora.com), con sede en Ciudad Juárez, Chihuahua, México, es responsable del tratamiento de tus datos personales conforme a
          la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y demás normativa aplicable. Para oír y recibir cualquier aviso,
          solicitud o notificación relacionada con tus datos, el medio de contacto es el correo del área de privacidad indicado abajo.
        </p>
        <p>
          Contacto del área de privacidad: <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.
        </p>

        <h2>2. KEORA y tu iglesia</h2>
        <p>
          KEORA es una herramienta que usan las iglesias para organizarse. Hay dos papeles distintos:
        </p>
        <ul>
          <li>
            <strong>Tu cuenta de KEORA</strong> (nombre, correo, contraseña, datos de registro): KEORA es el responsable.
          </li>
          <li>
            <strong>La información que tu iglesia registra y administra</strong> (membresía, asistencia, ministerios, ofrendas, consejería, datos de niños, etc.):
            la iglesia es la responsable y KEORA actúa como <em>encargado</em>, es decir, la guarda y la procesa solo por cuenta de la iglesia y siguiendo
            sus instrucciones. Para ejercer tus derechos sobre esa información puedes acudir a tu iglesia o escribirnos y la canalizaremos.
          </li>
        </ul>

        <h2>3. Datos personales que tratamos</h2>
        <ul>
          <li>
            <strong>Identificación:</strong> nombre y apellidos, fecha y lugar de nacimiento, género y fotografía de perfil (opcional).
          </li>
          <li>
            <strong>Contacto:</strong> correo electrónico, teléfonos y domicilio.
          </li>
          <li>
            <strong>Vida en la iglesia:</strong> iglesias a las que perteneces, membresía, bautismo y otras ordenanzas, asistencia a cultos y eventos,
            ministerios y servicio, grupos, clases, peticiones de oración, testimonios y lo que publiques en la app.
          </li>
          <li>
            <strong>Familia y menores de edad:</strong> integrantes de tu familia y datos de niños que registres tú como madre, padre o tutor, o la iglesia
            con tu autorización (por ejemplo, para la guardería).
          </li>
          <li>
            <strong>Datos patrimoniales o financieros:</strong> registro de diezmos, ofrendas y donativos, saldo del monedero y compras en la iglesia. Los pagos
            con tarjeta los procesan Mercado Pago o Stripe; KEORA <strong>no guarda</strong> números de tarjeta.
          </li>
          <li>
            <strong>Datos técnicos:</strong> dirección IP, tipo de dispositivo y navegador, cookies de sesión, registro de accesos y de acciones (bitácora
            de seguridad) y, si activas los avisos al celular, el identificador de tu dispositivo para enviarlos.
          </li>
        </ul>
        <p>
          <strong>Datos personales sensibles.</strong> Tu pertenencia a una iglesia, tus creencias religiosas, el bautismo, las peticiones de oración y la
          consejería pastoral son datos sensibles. Los tratamos con medidas de seguridad reforzadas y <strong>solo con tu consentimiento expreso</strong>, que
          otorgas al crear tu cuenta marcando la casilla correspondiente. Las notas de consejería solo las ven las personas autorizadas por la iglesia y cada
          acceso queda registrado.
        </p>

        <h2>4. Finalidades</h2>
        <p>
          <strong>Finalidades necesarias</strong> (sin ellas no podemos darte el servicio):
        </p>
        <ul>
          <li>Crear y administrar tu cuenta, verificar tu correo y permitirte iniciar sesión de forma segura.</li>
          <li>Vincularte con la o las iglesias a las que te unas y permitir que te administren como miembro, visitante o servidor.</li>
          <li>
            Dar los servicios de la app: cultos y asistencia, eventos, ministerios, calendario, oración, clases, guardería, comunicación, cafetería, monedero,
            donativos y demás funciones que use tu iglesia.
          </li>
          <li>Enviarte avisos relacionados con el servicio por correo, dentro de la app o al celular (si los activas).</li>
          <li>Procesar pagos y cobrar las suscripciones de las iglesias.</li>
          <li>Proteger la plataforma: prevenir fraudes y accesos indebidos y llevar la bitácora de seguridad.</li>
          <li>Cumplir obligaciones legales y atender requerimientos de autoridades.</li>
        </ul>
        <p>
          <strong>Finalidades secundarias</strong> (puedes negarte y seguirás usando KEORA):
        </p>
        <ul>
          <li>Informarte de novedades y mejoras de KEORA.</li>
          <li>Encuestas de satisfacción y estadísticas para mejorar el servicio (de preferencia con datos agregados, sin identificarte).</li>
        </ul>
        <p>
          Si no quieres que usemos tus datos para las finalidades secundarias, escríbenos a <a href={`mailto:${CONTACT}`}>{CONTACT}</a> con el asunto
          «Finalidades secundarias».
        </p>

        <h2>5. ¿Con quién compartimos tus datos?</h2>
        <p>
          <strong>No vendemos ni rentamos tus datos.</strong> Solo los compartimos:
        </p>
        <ul>
          <li>
            <strong>Con la iglesia o iglesias a las que te unas</strong>, para las finalidades necesarias. Cada iglesia solo ve la información de su propia
            comunidad.
          </li>
          <li>
            <strong>Con autoridades competentes</strong>, cuando la ley lo exija.
          </li>
        </ul>
        <p>
          Además, nos apoyamos en proveedores que tratan datos por nuestra cuenta (encargados) y que están obligados a protegerlos: alojamiento y red
          (Cloudflare), envío de correos (Resend), pagos (Mercado Pago y Stripe) y avisos al celular (los servicios de notificación de Google, Apple, Mozilla y
          Microsoft, según tu dispositivo). Al abrir el mapa bíblico, tu navegador descarga las imágenes del mapa de OpenStreetMap. Algunos están fuera de México. Estas remisiones no requieren tu consentimiento.
        </p>

        <h2>6. Tus derechos ARCO y la revocación del consentimiento</h2>
        <p>
          Tienes derecho a <strong>Acceder</strong> a tus datos, <strong>Rectificarlos</strong> si son inexactos, <strong>Cancelarlos</strong> cuando ya no
          sean necesarios y <strong>Oponerte</strong> a su uso para fines específicos. También puedes <strong>revocar tu consentimiento</strong>, aunque en
          algunos casos no podremos atenderlo de inmediato por obligaciones legales, y revocarlo para las finalidades necesarias implica que ya no podamos darte
          el servicio.
        </p>
        <p>
          Muchos datos los puedes corregir tú mismo en <em>Mi perfil</em>. Para cualquier solicitud escribe a <a href={`mailto:${CONTACT}`}>{CONTACT}</a> desde
          el correo de tu cuenta e incluye:
        </p>
        <ol>
          <li>Tu nombre completo y un medio para responderte.</li>
          <li>Una identificación oficial (o la de tu representante y el documento que lo acredite).</li>
          <li>La descripción clara de los datos y del derecho que quieres ejercer.</li>
          <li>Cualquier documento que ayude a localizar tus datos (por ejemplo, la iglesia a la que perteneces).</li>
        </ol>
        <p>
          Te responderemos en un máximo de <strong>20 días hábiles</strong> y, si procede, lo haremos efectivo dentro de los <strong>15 días hábiles</strong>{' '}
          siguientes. Si la información la administra tu iglesia, la canalizaremos con ella.
        </p>

        <h2>7. Cómo limitar el uso de tus datos</h2>
        <ul>
          <li>En tu perfil eliges quién ve tu teléfono y otros datos.</li>
          <li>Puedes desactivar los avisos al celular en cualquier momento desde Notificaciones o desde la configuración de tu dispositivo.</li>
          <li>Puedes pedirnos por correo que dejemos de enviarte comunicaciones que no sean del servicio.</li>
        </ul>

        <h2>8. Cookies y tecnologías similares</h2>
        <p>
          Usamos una cookie de sesión, indispensable para mantenerte conectado, y el almacenamiento local del navegador para recordar preferencias (como
          ocultar un aviso). <strong>No usamos cookies de publicidad ni rastreadores de terceros.</strong> Si bloqueas las cookies, no podrás iniciar sesión.
        </p>

        <h2>9. Menores de edad</h2>
        <p>
          Las cuentas de KEORA son para personas mayores de 18 años. Los datos de niñas, niños y adolescentes solo los registran su madre, padre o tutor, o la
          iglesia con su autorización, y se usan únicamente para su cuidado y participación en la iglesia (por ejemplo, la entrega segura en la guardería).
        </p>

        <h2>10. Seguridad y conservación</h2>
        <p>
          Protegemos tus datos con conexiones cifradas, contraseñas guardadas de forma irreversible, separación estricta entre iglesias, permisos por función
          y bitácora de accesos. Conservamos tus datos mientras tu cuenta o tu relación con la iglesia estén activas; después los bloqueamos y los eliminamos
          cuando terminen los plazos legales aplicables.
        </p>

        <h2>11. Cambios a este aviso</h2>
        <p>
          Cualquier cambio lo publicaremos en esta página (mykeora.com/privacidad) con su fecha de actualización y, si es importante, te avisaremos en la app o
          por correo.
        </p>

        <h2>12. Autoridad</h2>
        <p>
          Si consideras que tu derecho a la protección de datos fue vulnerado, puedes acudir ante la autoridad competente en materia de protección de datos
          personales (actualmente, la Secretaría Anticorrupción y Buen Gobierno).
        </p>

        <p className="legal__back">
          <Link to="/">← Volver a KEORA</Link>
        </p>
      </main>
      <footer className="landing__footer">
        <span>© KEORA</span> · <Link to="/terminos">Términos y condiciones</Link>
      </footer>
    </div>
  );
}
